import Component from '@glimmer/component';

import { hash } from '@ember/helper';

import Option_ from 'rise-ui/components/option.gjs';
import OptionPlaceholder from 'rise-ui/components/option-placeholder.gjs';

export default class SelectComponent extends Component {
  <template>
    <select class="c-select" ...attributes>
      {{#let
        (component Option_ selected=@selected)
        (component OptionPlaceholder selected=@selected)
        as | option placeholder |
      }}
      {{~yield (hash
        option=option
        Option=option
        placeholder=placeholder
        Placeholder=placeholder
      )~}}
      {{/let}}
    </select>
  </template>
}
